// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MoistureIndicator_frame__mWKZ1 {
  border: 1.5px solid gray;
  background-color: white;
  border-radius: 4px;
  width: 24px;
  height: 100%;
  padding: 2px;
}

.MoistureIndicator_moisture-indicator__eWc7P {
  border-radius: 2px;
  width: 100%;
  height: 100%;
}

.MoistureIndicator_dry__oMEiu {
  background-color: forestgreen;
}

.MoistureIndicator_moist__BsLAU {
  background-color: gold;
}

.MoistureIndicator_very-moist__u4Hqr {
  background-color: red;
}

.MoistureIndicator_na__oZG5p {
  background-color: black;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/MoistureIndicator.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,uBAAA;AACF","sourcesContent":[".frame {\n  border: 1.5px solid gray;\n  background-color: white;\n  border-radius: 4px;\n  width: 24px;\n  height: 100%;\n  padding: 2px;\n}\n\n.moisture-indicator {\n  border-radius: 2px;\n  width: 100%;\n  height: 100%;\n}\n\n.dry {\n  background-color: forestgreen;\n}\n\n.moist {\n  background-color: gold;\n}\n\n.very-moist {\n  background-color: red;\n}\n\n.na {\n  background-color: black;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `MoistureIndicator_frame__mWKZ1`,
	"moisture-indicator": `MoistureIndicator_moisture-indicator__eWc7P`,
	"dry": `MoistureIndicator_dry__oMEiu`,
	"moist": `MoistureIndicator_moist__BsLAU`,
	"very-moist": `MoistureIndicator_very-moist__u4Hqr`,
	"na": `MoistureIndicator_na__oZG5p`
};
export default ___CSS_LOADER_EXPORT___;
